import { render, staticRenderFns } from "./ArticleFiles.vue?vue&type=template&id=89dd988a&scoped=true"
import script from "./ArticleFiles.vue?vue&type=script&lang=js"
export * from "./ArticleFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd988a",
  null
  
)

export default component.exports